(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDeleteController',ScriptsTypesDeleteController);

    ScriptsTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScriptsTypes'];

    function ScriptsTypesDeleteController($uibModalInstance, entity, ScriptsTypes) {
        var vm = this;
        vm.scriptsTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ScriptsTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
